var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TaskList',{attrs:{"title":"Audit Report","taskType":"audit_report"}})
}
var staticRenderFns = []

export { render, staticRenderFns }